export default class LoginBase {
  constructor() {
    this.init = false;
  }
  async initLogin() {
    console.log('LoginBase initLogin');
  }
  async login(params) {
    console.log('LoginBase login|param=', params);
  }
  async checkLogin(params) {
    console.log('LoginBase checkLogin|param=', params);
    return { isLogin: false, userInfo: {} };
  }
  async logout(params) {
    console.log('LoginBase logout|param=', params);
  }
  async checkRoleInfo(params) {
    console.log('LoginBase checkRoleInfo|param=', params);
    return {
      defaultPlugin: true,
      isRoleReady: false,
      roleInfo: {},
    };
  }
}
